import { Progress, Skeleton } from "frontend-components";
import { getStatusColorByApiKey, getStatusDotClassByApiKey } from "./issuesStatusConstants";

type IssuesStatusItemProps = {
    status: string;
    statusKey: string;
    count: number;
    percentage: number;
    isLoading: boolean;
};

export function IssuesStatusItem({
    status,
    statusKey,
    count,
    percentage,
    isLoading,
}: IssuesStatusItemProps) {
    if (isLoading) {
        return (
            <div className="grid grid-cols-[minmax(0,1fr)_minmax(0,2fr)_2.5rem] items-center gap-4 px-5 py-3.5">
                <div className="flex items-center gap-2.5">
                    <Skeleton className="bg-compendia-greige-60 h-2 w-2 rounded-full" />
                    <Skeleton className="bg-compendia-greige-60 h-3 w-24 rounded" />
                </div>
                <Skeleton className="bg-compendia-greige-60 h-2 w-full rounded-full" />
                <Skeleton className="bg-compendia-greige-60 h-3 w-6 rounded" />
            </div>
        );
    }

    const progressColor = getStatusColorByApiKey(statusKey);
    const dotClass = getStatusDotClassByApiKey(statusKey);

    return (
        <div className="grid grid-cols-[minmax(0,1fr)_minmax(0,2fr)_2.5rem] items-center gap-4 px-5 py-3.5">
            <div className="flex items-center gap-2.5">
                <span className={`h-2 w-2 shrink-0 rounded-full ${dotClass}`} />
                <span className="text-text-primary text-label font-normal">{status}</span>
            </div>
            <Progress value={percentage} color={progressColor} />
            <span className="text-text-primary text-label text-right font-medium tabular-nums">
                {count}
            </span>
        </div>
    );
}
